import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
    UserProfile,
    UserCompany,
    UserBilling,
    UserSpaces,
    Error404,
} from '../domains';

const UserRoutes = () => {
    return (
        <Switch>
            <Route exact path="/user/profile" component={UserProfile} />
            <Route exact path="/user/company" component={UserCompany} />
            <Route exact path="/user/billing" component={UserBilling} />
            <Route exact path="/user/spaces" component={UserSpaces} />
            <Route component={Error404} />
        </Switch>
    );
};

export default UserRoutes;
